import banappConfig from '../../../../../banapp.config';

export type FullStoryConfig = {
  orgId: string;
  enabled: boolean;
  consentId: string;
};

/**
 * Gets FullStory configuration from banapp.config
 */
export function getFullStoryConfig(): FullStoryConfig {
  const config = banappConfig();
  return config.fullstory;
}

export function getRegistrationUrl(): string {
  const { oidcDiscoveryUrl } = banappConfig();
  const loginOrigin = new URL(oidcDiscoveryUrl).origin;

  return `${loginOrigin}/register/register.jsp?service=akademie`;
}
